<template>
  <div class="common-space-between container">
       <navBtnBlock @getVal="getVal"></navBtnBlock>
       <div class="right-div" 
            :style='{width:(this.$store.state.windowwidth-this.$store.state.leftBlockWidth-this.$store.state.ResetrouterNavWidth-this.$store.state.indexPadding*2)+"px",
                     height:(this.$store.state.windowHeight-130)+"px"
            }'>
           <ShowBtns/>
           <div class="common-space-between common-items-center">
               <div class="common-items-center">
                  <InputBlock title="类型名称">
                     <el-input v-model="name" :size="this.$store.state.inputSize" placeholder="请输入分类名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
                  </InputBlock>
                  <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="searchBtn">搜索</el-button>
                  <el-button type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
               </div>
           </div>
           <div class="warp-table">
            <el-table ref="giftTable" :data="tableData" :empty-text="this.$store.state.tableEmpty" :size="this.$store.state.tableSize" style="width:100%"  row-key="id"  :height="this.$store.state.windowHeight-260">
               <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="date"  label="序号"    width="80">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
               </el-table-column>
               <el-table-column  prop="name"  label="类型名称"  width="200"></el-table-column>
               <el-table-column align="center" header-align="center" prop="code"  label="在线icon"     width="200">
                  <template slot-scope="scope">
                     <div>
                         <div v-if="!scope.row.deviceTypeBanners">
                            <img class="badImg" src="@/assets/custom-icon/bad.png"/>
                         </div>
                         <div v-else>
                              <el-image  class="badImg" 
                               :src="scope.row.deviceTypeBanners.map(e=>e.code == 'online'? e.resourceUrl:require('@/assets/custom-icon/bad.png'))[scope.row.deviceTypeBanners.map(e=>e.code).indexOf('online')] || require('@/assets/custom-icon/bad.png')"
                               :preview-src-list="[scope.row.deviceTypeBanners.map(e=>e.code == 'online'? e.resourceUrl:require('@/assets/custom-icon/bad.png'))[scope.row.deviceTypeBanners.map(e=>e.code).indexOf('online')] || require('@/assets/custom-icon/bad.png')]"
                              />
                           </div>
                     </div>
                  </template>      
               </el-table-column>
               <el-table-column align="center" header-align="center" prop="code"  label="报警icon"     width="200">
                  <template slot-scope="scope">
                     <div>
                         <div v-if="!scope.row.deviceTypeBanners">
                            <img class="badImg" src="@/assets/custom-icon/bad.png"/>
                         </div>
                         <div v-else>
                              <el-image  class="badImg" 
                               :src="scope.row.deviceTypeBanners.map(e=>e.code == 'police'? e.resourceUrl:require('@/assets/custom-icon/bad.png'))[scope.row.deviceTypeBanners.map(e=>e.code).indexOf('police')] || require('@/assets/custom-icon/bad.png')"
                               :preview-src-list="[scope.row.deviceTypeBanners.map(e=>e.code == 'police'? e.resourceUrl:require('@/assets/custom-icon/bad.png'))[scope.row.deviceTypeBanners.map(e=>e.code).indexOf('police')] || require('@/assets/custom-icon/bad.png')]"
                              />
                           </div>
                     </div>
                  </template> 
               </el-table-column>
               <el-table-column align="center" header-align="center" prop="code"  label="故障icon"     width="200">
                  <template slot-scope="scope">
                     <div>
                         <div v-if="!scope.row.deviceTypeBanners">
                            <img class="badImg" src="@/assets/custom-icon/bad.png"/>
                         </div>
                         <div v-else>
                           <el-image  class="badImg" 
                              :src="scope.row.deviceTypeBanners.map(e=>e.code == 'fault'? e.resourceUrl:require('@/assets/custom-icon/bad.png'))[scope.row.deviceTypeBanners.map(e=>e.code).indexOf('fault')] || require('@/assets/custom-icon/bad.png')"
                              :preview-src-list="[scope.row.deviceTypeBanners.map(e=>e.code == 'fault'? e.resourceUrl:require('@/assets/custom-icon/bad.png'))[scope.row.deviceTypeBanners.map(e=>e.code).indexOf('fault')] || require('@/assets/custom-icon/bad.png')]"
                              />
                         </div>
                     </div>
                  </template> 
               </el-table-column>
               <el-table-column align="center" header-align="center" prop="code"  label="离线icon"     width="200">
                  <template slot-scope="scope">
                     <div>
                         <div v-if="!scope.row.deviceTypeBanners">
                            <img class="badImg" src="@/assets/custom-icon/bad.png"/>
                         </div>
                         <div v-else >
                              <el-image  class="badImg" 
                              :src="scope.row.deviceTypeBanners.map(e=>e.code == 'unline'? e.resourceUrl:require('@/assets/custom-icon/bad.png'))[scope.row.deviceTypeBanners.map(e=>e.code).indexOf('unline')] || require('@/assets/custom-icon/bad.png')"
                              :preview-src-list="[scope.row.deviceTypeBanners.map(e=>e.code == 'unline'? e.resourceUrl:require('@/assets/custom-icon/bad.png'))[scope.row.deviceTypeBanners.map(e=>e.code).indexOf('unline')] || require('@/assets/custom-icon/bad.png')]"
                              />
                         </div>
                     </div>
                  </template>
               </el-table-column>
               <el-table-column  prop="createTime" :show-overflow-tooltip="true" label="更新时间" width="200"> </el-table-column>
               <el-table-column  prop="operator" :show-overflow-tooltip="true" align="center" header-align="center" label="最近操作人" width="200">
                  <template slot-scope="scope">
                     <div class="common-space-around">
                       <span v-if="!scope.row.operator" class="disable">--</span>
                       <span v-else class="open">{{scope.row.operator}}</span>
                     </div>
                  </template>
               </el-table-column>

               <el-table-column  prop="address" :show-overflow-tooltip="true" label="操作" fixed="right" width="110" align="center" header-align="center">
                  <template slot-scope="scope">
                     <div class="common-space-around common-items-center operate">
                        <div v-if="!scope.row.deviceTypeBanners" >
                            <el-link  @click="addBtn(scope.row)" :underline="false" type="primary">新增</el-link>
                        </div>
                        <div v-else>
                            <div v-if="scope.row.deviceTypeBanners.length==4">
                               <el-link  @click="ediBtn(scope.row)" :underline="false" type="primary" style="color:#1AA034;">编辑</el-link>
                            </div> 
                            <div v-else >
                               <el-link  @click="addBtn(scope.row)" :underline="false" type="primary">新增</el-link>
                               &nbsp;
                               <el-link  @click="ediBtn(scope.row)" :underline="false" type="primary" style="color:#1AA034;">编辑</el-link>
                           </div>
                        </div> 
                    </div>
                  </template>
               </el-table-column>
            </el-table>
            <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size"/>
           </div>
       </div>
       <AddBlock  ref="add"></AddBlock>
       <EidtBlock ref="eidt"></EidtBlock>
  </div>
</template>
<script>
import { scroll } from '@/components/component-mixin/block-scroll'
import navBtnBlock from './common-module/equipment-navBtn-block.vue'
import AddBlock from './common-module/add-block.vue'
import EidtBlock from './common-module/eidt-block.vue'
import {url,iotApi} from '@/utils/config'
import {setRouterNav} from '@/utils/util'
import {postFun,deleteFun,getFun,putFun} from '@/utils/httpFun'
export default {
  name: 'index',
  mixins: [scroll],
  components:{
      AddBlock:AddBlock,
      EidtBlock:EidtBlock,
      navBtnBlock:navBtnBlock
  },
  data:()=>({  
    tableData: [{}],
    team:{},
    name:null,
    enabled:null,
    factoryName:null,
    current:1,
    size:10,
    total:10,  
  }),
  created(){
     setRouterNav()
     this.size = this.$store.state.pageSize
     this.iconList = this.$store.state.conText.iconList
  },
  methods:{

    //获取所有的数据
    async getList(){
        let parms = {
               param:{
                  parentId:this.team.id,
                  name:this.name,
                  enabled:this.enabled,
                  factoryName:this.factoryName
               },
               current:this.current,
               size:this.size
         }
        await postFun(iotApi.FACTLITYMINLIST,parms,res=>{
             let list = res.data.records
             this.tableData = list 
             this.total = res.data.total
             this.size = res.data.size
             this.current = res.data.current
        })
    },

    //搜索
    searchBtn(){
      this.getList()
    },

    resetBtn(){
      this.name = null
      this.current = 1
      this.getList()
    },

   
   //获取左侧单位组织
    getVal(ev){
       this.team = ev
       this.enabled = null
       this.name = null
       this.getList()
    },

    //新增单位组织弹窗父节点
    addBtn(ev){
       let list = this.$store.state.conText.iconList
       let listA = []
       let listB = []
       let listArray = []
       for(var i in ev.deviceTypeBanners){
          listA.push(ev.deviceTypeBanners[i].code)
       }
       for(var j in list){
         listB.push(list[j].val)
       }
       let selectVal =  listB.filter(function (val) { return listA.indexOf(val) === -1 })
       for(var i in selectVal){
          for(var j in list){
             if(selectVal[i]==list[j].val){
                 listArray.push(list[j])
             } 
          } 
       } 
       ev.listIcon = listArray 
       ev.IconCode = selectVal[0]
       this.$refs.add.showBlockMe(ev);
    },

    //编辑单位组织弹窗
    ediBtn(ev){
       ev.listIcon = this.$store.state.conText.iconList 
       this.$refs.eidt.showBlockMe(ev);
    },

    //分页
    getPage(ev){
        this.size = ev.pageSize
        this.current = ev.pageNo 
        this.getList()
    }
   }
}
</script>
<style lang="scss" scoped>
    .badImg{
      width: 25px;
      border-radius:4px;
    }
    .right-div{
       position: relative;
       border: 1px solid rgba(240,240,240,0.2);
       box-shadow: -3px 3px 9px 0px rgba(205,216,233,0.2);
       padding:15px 15px 15px 22px;
       box-sizing: border-box;
       .warp-btn{
         display: flex;
         justify-content: flex-end;
       }
       .warp-table{
          padding-top:15px;
       }
       .operate{
          ::v-deep .el-button--mini{
            padding: 5px 8px;
          }
       }
    }
</style>
